export const STATUS_OPTIONS = [
  { value: "new", label: "New" },
  { value: "reviewing", label: "Reviewing" },
  { value: "need_photos", label: "Need Photos" },
  { value: "quote_sent", label: "Quote Sent" },
  { value: "approved", label: "Approved" },
  { value: "in_progress", label: "In Progress" },
  { value: "complete", label: "Complete" },
  { value: "archived", label: "Archived" },
];
